import { render, staticRenderFns } from "./ITRExpensesFormsPresenceCard.vue?vue&type=template&id=450cb6cc&scoped=true&"
import script from "./ITRExpensesFormsPresenceCard.vue?vue&type=script&lang=ts&"
export * from "./ITRExpensesFormsPresenceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450cb6cc",
  null
  
)

export default component.exports